export default [
    {
        code: 'NAME',
        name: 'Property Name',
    },
    {
        code: 'ADDRESS',
        name: 'Address',
    },
    {
        code: 'CITY',
        name: 'City',
    },
    {
        code: 'STATE',
        name: 'State',
    },
    {
        code: 'ZIP',
        name: 'Zip',
    },
    {
        code: 'MARKET',
        name: 'Market',
    },
    {
        code: 'STATUS',
        name: 'Status',
    },
    {
        code: 'HSC_STATUS',
        name: 'PEAK Status',
    },
    {
        code: 'SOURCE',
        name: 'Source',
    },
    {
        code: 'TRANSACTION_TYPE',
        name: 'Transaction Type',
    },
    {
        code: 'CATEGORY',
        name: 'Category',
    },
    {
        code: 'TYPE',
        name: 'Type',
    },
    {
        code: 'SINGLE_TENANT_SUBCATEGORY',
        name: 'STNL Tenant subcategory',
    },
    {
        code: 'LEASE_TYPE',
        name: 'Lease Type',
    },
    {
        code: 'MULTI_TENANT_SUBCATEGORY',
        name: 'MT Tenant subcategory',
    },
    {
        code: 'TENANT_ID',
        name: 'Tenant',
    },
    {
        code: 'SQFT',
        name: 'Square Feet',
    },
    {
        code: 'YEAR_BUILT',
        name: 'Year Built',
    },
    {
        code: 'LIST_PRICE',
        name: 'List Price',
    },
    {
        code: 'CAPITALIZATION_RATE',
        name: 'List Cap Rate',
    },
    {
        code: 'PRICE_PER_SQFT',
        name: 'Price per Square Foot',
    },
    {
        code: 'SOLD_PRICE',
        name: 'Price at Close',
    },
    {
        code: 'CLOSE_CAP_RATE',
        name: 'Cap Rate at Close',
    },
    {
        code: 'CLOSE_PRICE_PER_SQFT',
        name: 'Price per Square Foot at Close',
    },
    {
        code: 'NET_OPERATING_INCOME',
        name: 'Net Operating Income',
    },
    {
        code: 'VACANCY',
        name: 'Occupancy',
    },
    {
        code: 'LEASE_EXPIRATION_DATE',
        name: 'Remaining Term',
    },
    {
        code: 'CLOSE_OF_ESCROW',
        name: 'Close of Escrow',
    },
    {
        code: 'LISTED_DATE',
        name: 'Date Listed',
    },
    {
        code: 'SELLER_COMPANY_STATE',
        name: 'Seller State',
    },
    {
        code: 'STRIVE_AGENT_TEAM',
        name: 'SUMMIT Team Member',
    },
    {
        code: 'LISTING_AGENT_4',
        name: 'Listing Agent',
    },
    {
        code: 'LISTING_AGENT_4_FIRM',
        name: 'Listing Agent Firm',
    },
    {
        code: 'BUYER_COMPANY_STATE',
        name: 'Buyer State',
    },
    {
        code: 'BUYER_AGENT_4',
        name: 'Buying Agent',
    },
    {
        code: 'BUYER_AGENT_4_FIRM',
        name: 'Buying Agent Firm',
    },
    {
        code: 'MEDIA_KIT',
        name: 'OM',
    },
    //Blerina added this
    {
        code: 'ACRES',
        name: 'Acres',
    },
    {
        code: 'NOTES',
        name: 'Notes',
    },
    {
        code: 'COUNTY',
        name: 'County',
    },
    {
        code: 'CAD_SITE',
        name: 'Cad Site',
    },
    {
        code: 'ACCOUNT_NUMBER',
        name: 'Account Number',
    },
    {
        code: 'ASSESSED_VALUE',
        name: 'Assessed Value',
    },
    {
        code: 'ASSESSED_YEAR',
        name: 'Assessed Year',
    },
    {
        code: 'TRANS_DATE',
        name: 'Transaction Date',
    },
    {
        code: 'TRANS_PRICE',
        name: 'Transaction Price',
    },
    {
        code: 'LEGAL_DESC',
        name: 'Legal Description',
    },
    {
        code: 'LISTING_AGENT_1',
        name: 'Listing Agent 1',
    },
    {
        code: 'LISTING_AGENT_2',
        name: 'Listing Agent 2',
    },
    {
        code: 'LISTING_AGENT_3',
        name: 'Listing Agent 3',
    },
    {
        code: 'REFERRING_LISTING_AGENT',
        name: 'Referring Listing Agent',
    },
    {
        code: 'REFERRING_LISTING_AGENT_PERCENT',
        name: 'Referring Listing Agent Percent',
    },
    {
        code: 'REFERRING_LISTING_AGENT_FIRM',
        name: 'Referring Listing Agent Firm',
    },
    {
        code: 'REFERRING_BUYER_AGENT',
        name: 'Referring Buyer Agent',
    },
    {
        code: 'REFERRING_BUYER_AGENT_PERCENT',
        name: 'Referring Buyer Agent Percent',
    },
    {
        code: 'REFERRING_BUYER_AGENT_FIRM',
        name: 'Referring Buyer Agent Firm',
    },
    {
        code: 'STRENGTHS',
        name: 'Strengths',
    },
    {
        code: 'CHALLENGES',
        name: 'Challenges',
    },
    {
        code: 'BUYER_POOL',
        name: 'Buyer Pool',
    },
    {
        code: 'QUALIFICATIONS',
        name: 'Qualifications',
    },
    {
        code: 'RECOMMENDATIONS',
        name: 'Recommendations',
    },
    {
        code: 'SELLER_FEE_PERCENTAGE',
        name: 'Fee Percentage',
    },
    {
        code: 'RENT_PER_SQFT',
        name: 'Rent Sq Ft - Auto',
    },
    {
        code: 'TOTAL_FEE',
        name: 'Summit Fee - Auto',
    },
    {
        code: 'BUYER_ID',
        name: 'Buyer',
    },
    {
        code: 'BUYER_EMAIL',
        name: 'Buyer Email',
    },
    {
        code: 'INVESTOR_EMAIL',
        name: 'Investor Email',
    },
    {
        code: 'BUYER_AGENT_1',
        name: 'Buyer Agent 1',
    },
    {
        code: 'BUYER_AGENT_2',
        name: 'Buyer Agent 2',
    },
    {
        code: 'BUYER_AGENT_3',
        name: 'Buyer Agent 3',
    },
    {
        code: 'VIDEO_URL',
        name: 'Video URL',
    },
    {
        code: 'FLIP_BOOK',
        name: 'Flip Book',
    },
    {
        code: 'HIGHLIGHTS',
        name: 'Highlights',
    },
    {
        code: 'WEBSITE_PHOTO_1',
        name: 'Photo',
    },
    //arianit added
    {
        code: 'UNITS',
        name: 'Units',
    },
    {
        code: 'LATITUDE',
        name: 'Latitude',
    },
    {
        code: 'LONGITUDE',
        name: 'Longitude',
    },
    {
        code: 'DOWN_PAYMENT',
        name: 'Down Payment',
    },
    {
        code: 'SELLER_ID',
        name: 'Seller',
    },
    {
        code: 'LEASE_COMMENCEMENT_DATE',
        name: 'Lease Commencement Date',
    },
    {
        code: 'CLOSE_NOI',
        name: 'Close NOI',
    },
    {
        code: 'PROFORMA_NOI',
        name: 'Proforma NOI',
    },
    {
        code: 'PROFORMA_BASE_RENT',
        name: 'Proforma Base Rent',
    },
    {
        code: 'PROFORMA_CAP_RATE',
        name: 'Proforma Cap Rate',
    },
    {
        code: 'LISTING_AGENT_1_PERCENT',
        name: 'Listing Agent 1 Percent',
    },
    {
        code: 'LISTING_AGENT_2_PERCENT',
        name: 'Listing Agent 2 Percent',
    },
    {
        code: 'LISTING_AGENT_3_PERCENT',
        name: 'Listing Agent 3 Percent',
    },
    {
        code: 'LISTING_AGENT_4_PERCENT',
        name: 'Listing Agent 4 Percent',
    },
    {
        code: 'BUYER_AGENT_1_PERCENT',
        name: 'Buyer Agent 1 Percent',
    },
    {
        code: 'BUYER_AGENT_2_PERCENT',
        name: 'Buyer Agent 2 Percent',
    },
    {
        code: 'BUYER_AGENT_3_PERCENT',
        name: 'Buyer Agent 3 Percent',
    },
    {
        code: 'BUYER_AGENT_4_PERCENT',
        name: 'Buyer Agent 4 Percent',
    },
    {
        code: 'NEGOTIATION_PRICE',
        name: 'Negotiation Price',
    },
    {
        code: 'POTENTIAL_FEE',
        name: 'Potential Fee',
    },
    {
        code: 'LIST_FEE',
        name: 'List Fee',
    },
    {
        code: 'BUYSIDE_FEE',
        name: 'Buyside Fee',
    },
    {
        code: 'NEGOTIATION_CAP_RATE',
        name: 'Negotiation Cap Rate',
    },
    {
        code: 'HIDE_FINANCIALS',
        name: 'Hide Financials',
    },
    {
        code: 'IS_PROFORMA_PRICING',
        name: 'Is Proforma Pricing',
    },
    {
        code: 'DATE_REMOVED',
        name: 'Date Removed',
    },
    {
        code: 'NEGOTIATION_PRICE_PER_SQFT',
        name: 'Negotiation Price Per Sqft',
    },
    {
        code: 'BASE_RENT',
        name: 'Base Rent',
    },
    {
        code: 'EXPIRATION_NO_OF_MONTHS',
        name: 'Expiration No Of Months',
    },
    {
        code: 'EXPIRATION_DATE',
        name: 'Expiration Date',
    },
    {
        code: 'EFFECTIVE_DATE',
        name: 'Effective Date',
    },
    {
        code: 'REFERRAL_FEE',
        name: 'Referral Fee',
    },
    {
        code: 'HSC_TEAM_MEMBER_1',
        name: 'HSC Team Member 1',
    },
    {
        code: 'HSC_TEAM_MEMBER_1_PERCENT',
        name: 'HSC Team Member 1 Percent',
    },
    {
        code: 'HSC_TEAM_MEMBER_1_NET_FEE',
        name: 'HSC Team Member 1 Net Fee',
    },
    {
        code: 'HSC_TEAM_MEMBER_1_NET_PERCENT',
        name: 'HSC Team Member 1 Net Percent',
    },
    {
        code: 'HSC_TEAM_MEMBER_1_GROSS_FEE',
        name: 'HSC Team Member 1 Gross Fee',
    },
    {
        code: 'HSC_TEAM_MEMBER_2',
        name: 'HSC Team Member 2',
    },
    {
        code: 'HSC_TEAM_MEMBER_2_PERCENT',
        name: 'HSC Team Member 2 Percent',
    },
    {
        code: 'HSC_TEAM_MEMBER_2_NET_FEE',
        name: 'HSC Team Member 2 Net Fee',
    },
    {
        code: 'HSC_TEAM_MEMBER_2_NET_PERCENT',
        name: 'HSC Team Member 2 Net Percent',
    },
    {
        code: 'HSC_TEAM_MEMBER_2_GROSS_FEE',
        name: 'HSC Team Member 2 Gross Fee',
    },
    {
        code: 'HSC_AGREEMENT_FILE',
        name: 'HSC Agreement File',
    },
    {
        code: 'LOAN_COMMITMENT_FILE',
        name: 'Loan Commitment File',
    },
    {
        code: 'CLOSING_STATEMENT_FILE',
        name: 'Closing Statement File',
    },
    {
        code: 'LOAN_CLOSING_DATE',
        name: 'Loan Closing Date',
    },
    {
        code: 'HSC_APPROVED',
        name: 'HSC Approved',
    },
    {
        code: 'HSC_APPROVED_TIMESTAMP',
        name: 'HSC Approved Timestamp',
    },
    {
        code: 'HSC_APPROVED_INITIALS',
        name: 'HSC Approved Initials',
    },
    {
        code: 'HSC_PRICE',
        name: 'HSC Price',
    },
    {
        code: 'HSC_LISTED_DATE',
        name: 'HSC Listed Date',
    },
    {
        code: 'HSC_EXPIRATION_NO_OF_MONTHS',
        name: 'HSC Expiration No Of Months',
    },
    {
        code: 'HSC_EXPIRATION_DATE',
        name: 'HSC Expiration Date',
    },
    {
        code: 'HSC_FEE_PERCENTAGE',
        name: 'HSC Fee Percentage',
    },
    {
        code: 'HSC_TOTAL_FEE',
        name: 'HSC Total Fee',
    },
    {
        code: 'HSC_LIST_FEE',
        name: 'HSC List Fee',
    },
    {
        code: 'LENDER_ID',
        name: 'Lender',
    },
    {
        code: 'LOAN_TYPE',
        name: 'Loan Type',
    },
    {
        code: 'LTV',
        name: 'LTV',
    },
    {
        code: 'LOAN_AMOUNT',
        name: 'Loan Amount',
    },
    {
        code: 'INTEREST_RATE',
        name: 'Interest Rate',
    },
    {
        code: 'AMORTIZATION',
        name: 'Amortization',
    },
    {
        code: 'TERM',
        name: 'Term',
    },
    {
        code: 'MATURITY_DATE',
        name: 'Maturity Date',
    },
    {
        code: 'ANNUAL_LOAN_PAYMENT',
        name: 'Annual Loan Payment',
    },
    {
        code: 'CASH_FLOW',
        name: 'Cash Flow',
    },
    {
        code: 'CASH_ON_CASH',
        name: 'Cash On Cash',
    },
    {
        code: 'DSCR',
        name: 'DSCR',
    },
    {
        code: 'PREPAYMENT_PENALTY',
        name: 'Prepayment Penalty',
    },
    {
        code: 'CREDITS_AT_CLOSING',
        name: 'Credits At Closing',
    },
    {
        code: 'REFERRAL',
        name: 'Referral',
    },
    {
        code: 'REFERRAL_PERCENT',
        name: 'Referral Percent',
    },
    {
        code: 'NOI_PERCENT',
        name: 'NOI Percent',
    },
    {
        code: 'REFERRED_BY_ID',
        name: 'Referred By',
    },
    {
        code: 'REFERRED_BY_TYPE',
        name: 'Referred By Type',
    },
    {
        code: 'REFERRAL_TYPE',
        name: 'Referral Type',
    },
    {
        code: 'HSC_FINANCING',
        name: 'HSC Financing',
    },
    {
        code: 'DATE_CREATED',
        name: 'Date Created',
    },
    {
        code: 'OTHER_FINANCING',
        name: 'Other Financing',
    },
    {
        code: 'REP_AGREEMENT_FILE_1',
        name: 'Rep Agreement File 1',
    },
    {
        code: 'REP_AGREEMENT_FILE_2',
        name: 'Rep Agreement File 2',
    },
    {
        code: 'REP_AGREEMENT_FILE_3',
        name: 'Rep Agreement File 3',
    },
    {
        code: 'REP_AGREEMENT_FILE_4',
        name: 'Rep Agreement File 4',
    },
    {
        code: 'REP_AGREEMENT_FILE_5',
        name: 'Rep Agreement File 5',
    },
    {
        code: 'IN_NEG_FILE_1',
        name: 'In Neg File 1',
    },
    {
        code: 'IN_NEG_FILE_2',
        name: 'In Neg File 2',
    },
    {
        code: 'IN_NEG_FILE_3',
        name: 'In Neg File 3',
    },
    {
        code: 'IN_NEG_FILE_4',
        name: 'In Neg File 4',
    },
    {
        code: 'IN_NEG_FILE_5',
        name: 'In Neg File 5',
    },
    {
        code: 'SELLER_STATEMENT_FILE',
        name: 'Seller Statement File',
    },
    {
        code: 'BUYER_STATEMENT_FILE',
        name: 'Buyer Statement File',
    },
    {
        code: 'WEBSITE_PHOTO_2',
        name: 'Website Photo 2',
    },
    {
        code: 'WEBSITE_PHOTO_3',
        name: 'Website Photo 3',
    },
    {
        code: 'WEBSITE_PHOTO_4',
        name: 'Website Photo 4',
    },
    {
        code: 'WEBSITE_PHOTO_5',
        name: 'Website Photo 5',
    },
    {
        code: 'CREATED_BY',
        name: 'Created By',
    },
    {
        code: 'FLAGGED_DATE',
        name: 'Flagged Date',
    },
    {
        code: 'UNDER_CONTRACT_IN_NEGOTIATION_SINCE',
        name: 'Under Contract In Negotiation Since',
    },
    {
        code: 'PROPERTY_INFO_SINCE',
        name: 'Property Info Since',
    },
    {
        code: 'OFF_MARKET_SINCE',
        name: 'Off Market Since',
    },
    {
        code: 'LAST_MODIFIED_BY',
        name: 'Last Modified By',
    },
    {
        code: 'LAST_MODIFIED_DATE',
        name: 'Last Modified Date',
    },
    {
        code: 'UPLOADED_FROM',
        name: 'Uploaded From',
    },
    {
        code: 'IS_LISTING',
        name: 'Is Listing',
    },
    {
        code: 'WAS_PROPOSAL',
        name: 'Was Proposal',
    },
    {
        code: 'ESTIMATED_PRICE_TYPE',
        name: 'Estimated Price Type',
    },
    {
        code: 'SUB_CATEGORY',
        name: 'Sub Category',
    },
    {
        code: 'PROPOSAL_DATE',
        name: 'Proposal Date',
    },
    {
        code: 'BANK_BONUS',
        name: 'Bank Bonus',
    },
    {
        code: 'BANK_BONUS_PERCENT',
        name: 'Bank Bonus Percent',
    },
    {
        code: 'STREET',
        name: 'Street',
    },
    {
        code: 'CORE_PROPERTY',
        name: 'Core Property',
    },
    {
        code: 'NEED_INFO',
        name: 'Need Info',
    },
    {
        code: 'VISIBLE',
        name: 'Visible',
    },
    {
        code: 'FEATURED',
        name: 'Featured',
    },
];